export const DASHBOARD_LOAD = 'DASHBOARD_LOAD'
export const dashboardLoad = (accountId, projectId, moduleName) => ({
  type: DASHBOARD_LOAD,
  accountId,
  projectId,
  moduleName
})
